import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'not-found-page',
    templateUrl: './not-found-page.component.html',
    styleUrls: ['./not-found-page.component.css'],
    standalone: false
})
export class NotFoundPageComponent {
  constructor(private location: Location, private router: Router) {
    console.log(location.path());
    var prev = router.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString();
    console.log(prev);
  }
}
